import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {NgbDropdown} from "@ng-bootstrap/ng-bootstrap";
import {AladinService} from "../aladin.service";
import {tap} from "rxjs/operators";

export interface VOServiceItem {
  readonly name?: string;
  readonly url?: string;
  readonly instruments?: string[]
}

export interface VOServiceOverlay {
  readonly id?: string;
  readonly name?: string;
  readonly color?: string;
  readonly footprints?: string[];
}

const voServiceItems: VOServiceItem[] = [
  {
    name: 'HST',
    url: 'https://sky.esa.int/esasky-tap/tap/sync?' +
      'lang=ADQL' +
      '&format=VOTABLE' +
      '&query=SELECT+TOP+1000+*+FROM+observations.mv_v_v_hst_mmi_observation_optical_fdw_fdw+WHERE+1=INTERSECTS(fov,POLYGON(\'ICRS\',$POLYGON))'
  },
  {
    name: 'XSA',
    url: 'https://sky.esa.int/esasky-tap/tap/sync?' +
      'request=lang=ADQL' +
      '&format=VOTABLE' +
      '&query=SELECT TOP 1000 * FROM observations.mv_v_v_xsa_esasky_photo_fdw_fdw WHERE 1=INTERSECTS(fov,POLYGON(\'ICRS\',$POLYGON))'
  },
  {
    name: 'ESO',
    url: 'https://archive.eso.org/tap_obs/sync?' +
      'request=doQuery' +
      '&lang=ADQL' +
      '&format=VOTABLE' +
      '&query=select+top+1000+*+from+ivoa.obscore+where+instrument_name+=+\'$INSTRUMENT\'+and+1=INTERSECTS(s_region,POLYGON(\'ICRS\',$POLYGON))',
    instruments: [
      "APEXBOL",
      "APEXHET",
      "EFOSC",
      "EFOSC, SOFI",
      "ESPRESSO",
      "FEROS",
      "FORS1",
      "FORS2",
      "GIRAFFE",
      "GIRAFFE, UVES",
      "HARPS",
      "HAWKI",
      "ISAAC",
      "KMOS",
      "MUSE",
      "NAOS+CONICA",
      "NGTS",
      "OMEGACAM",
      "OMEGACAM, VIRCAM",
      "PIONIER",
      "SINFONI",
      "SOFI",
      "SPHERE",
      "UVES",
      "VIMOS",
      "VIRCAM",
      "VISIR",
      "XSHOOTER"
    ]
  },
  {
    name: 'CASDA',
    url: 'https://casda.csiro.au/casda_vo_tools/tap/sync?' +
      'request=doQuery' +
      '&lang=ADQL' +
      '&format=VOTABLE' +
      '&query=SELECT+TOP+500+*+FROM+ivoa.obscore+WHERE+1=INTERSECTS(s_region,POLYGON(\'ICRS\',$POLYGON))'
  }
]

@Component({
  selector: 'asax-sky-view-aladin-vo',
  templateUrl: './aladin-vo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AladinVoComponent {
  @ViewChild('dropdown', {static: true}) dropdown: NgbDropdown;

  @Input() voServicesOverlays: VOServiceOverlay[];

  @Output() outAddVoService = new EventEmitter<VOServiceItem>();
  @Output() outRemoveServiceOverlay = new EventEmitter<string>();

  voServiceItems = voServiceItems;

  constructor(private readonly aladinService: AladinService) {
    this.aladinService.getMouseClick().pipe(
      tap(() => this.dropdown?.close()),
    ).subscribe();
  }

  emitAddVoServiceItem(voServiceItem: VOServiceItem) {
    this.outAddVoService.emit(voServiceItem);
  }

  emitRemoveVoServiceOverlay(id: string) {
    this.outRemoveServiceOverlay.emit(id);
  }

  emitAddVoServiceInstrumentItem(instrument: string, voServiceItem: VOServiceItem) {
    const service = {
      ...voServiceItem,
      name: `${voServiceItem.name} - ${instrument}`,
      url: voServiceItem.url?.replace('$INSTRUMENT', instrument)
    };

    this.emitAddVoServiceItem(service);
  }
}
